import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ProductQuantities from './components/ProductQuantities';

const productQuantities = (props,{ t }) => (
  <Container>
    <ProductQuantities {...props} />
  </Container>
);

productQuantities.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(productQuantities);
